import { connect } from 'react-redux';

import { selectors as uploaderSelectors } from 'modules/uploader';

import ImageList from '../components/ImageList';

import { imagesUploader } from '../config';

export default connect(state => ({
    images: uploaderSelectors.selectFileList(state, imagesUploader),
}))(ImageList);
